import { createRouter, createWebHistory } from "vue-router";
//import Login from './Pages/Login.vue';
import Signup from './Pages/Signup.vue';
import HomePage from './Pages/HomePage.vue';
// import AboutUs from "./Pages/AboutUs.vue";
import Contact from "./Pages/Contact.vue";
import Services from "./Pages/Services.vue";
import Articles from "./Pages/Articles.vue";
//import MobileSolutions from "./Pages/MobileSolutions.vue";
//import FieldServices from "./Pages/FieldServices.vue";
//import ICDashboard from "./Pages/ICDashboard.vue";

const routes = [
{pathj:'/', component: HomePage},
//{path: '/login', component: Login},
{path: '/signup', component: Signup},
{path: '/homepage', component: HomePage},
{path: '/articles', component: Articles},
// {path: '/aboutus', component: AboutUs},
{path: '/contact', component: Contact},
{path: '/services', component: Services},
//{path: '/fieldservices', component:FieldServices},
//{path: '/mobilesolutions', component:MobileSolutions},
//{path: '/icdashboard', component:ICDashboard}
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router;